module.exports = __webpack_public_path__ + "img/cst_cha_count_noctilus_0.bab6bd9b.png";